import React, { createContext, useContext, } from 'react';
import { useLocation } from 'react-router-dom';
import { Layout, } from 'antd';
import { useApp } from '../../context/app-context';
import { StationContextProvider} from '../../context/station-context';
import { NocItemContextProvider } from '../../context/noc-item-context';
import { CustomerViewLayout } from '../../components/Dashboard/Station/CustomerViewLayout.component';
import { getStationPermissions } from '../../UserValidation';
import './StationScreen.css';

export const StationPermissionsContext = createContext(undefined);
export const NocItemContext = createContext(undefined);

export const UseNocItemContext = () => {
    return useContext(NocItemContext);
};

export const StationScreen = ({...props}) => {

    const {state: {user}} = useApp();
    const { pendingChangesModal, setPendingChangesModal, pendingState, setPendingState } = props;

    const location = useLocation();
    const { currentNocItem } = location.state;

    return (
        <>
            <StationPermissionsContext.Provider value={getStationPermissions(user)}>
                <NocItemContext.Provider value={ currentNocItem }>
                    <NocItemContextProvider>
                        <StationContextProvider>
                            <Layout className="station__layout" id={`noc-${currentNocItem.id}`}>
                                <CustomerViewLayout 
                                    pendingState={pendingState}
                                    setPendingState={setPendingState}
                                    pendingChangesModal={pendingChangesModal}
                                    setPendingChangesModal={setPendingChangesModal}
                                />
                            </Layout>
                        </StationContextProvider>
                    </NocItemContextProvider>
                </NocItemContext.Provider>
            </StationPermissionsContext.Provider>
        </>
    );
}